import RandingStyle9 from "../../randing/RandingStyle9";

function Randing259({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle9
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/259/01.jpg`} //맘스다방
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/pink/ApplyBenefitButton.png`}
      adTarget="맘카페 이용자"
      // privacyMessage="개인정보수집에 동의하시는 분만 '상담문의' 버튼을 눌러주세요."
      eventDates={true}
      companyName="세계로탑치과의원"
      footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/segyeroTop.png`}
    />
  );
}

export default Randing259;
